module.exports = __webpack_public_path__ + "media/images/blog-img-02-eb5a54ed29c3ad045b8803e454d44972.jpg";